import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a222550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-select-search__select" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-4a222550><g clip-path=\"url(#clip0_4351_26093)\" data-v-4a222550><path d=\"M2.83621 5.07088C2.32307 4.60906 1.53271 4.65066 1.07088 5.16379C0.609058 5.67693 0.650657 6.46729 1.16379 6.92912L2.83621 5.07088ZM6.10805 9.69724L5.27184 10.6264L5.27184 10.6264L6.10805 9.69724ZM12.8362 6.92912C13.3493 6.46729 13.3909 5.67693 12.9291 5.16379C12.4673 4.65066 11.6769 4.60906 11.1638 5.07088L12.8362 6.92912ZM7.89195 9.69724L8.72816 10.6264L8.72816 10.6264L7.89195 9.69724ZM1.16379 6.92912L5.27184 10.6264L6.94425 8.76812L2.83621 5.07088L1.16379 6.92912ZM11.1638 5.07088L7.05575 8.76812L8.72816 10.6264L12.8362 6.92912L11.1638 5.07088ZM5.27184 10.6264C6.2543 11.5106 7.7457 11.5106 8.72816 10.6264L7.05575 8.76812C7.02406 8.79665 6.97594 8.79665 6.94425 8.76812L5.27184 10.6264Z\" fill=\"#C6C6C6\" data-v-4a222550></path></g><defs data-v-4a222550><clipPath id=\"clip0_4351_26093\" data-v-4a222550><rect width=\"14\" height=\"14\" fill=\"white\" transform=\"translate(14 14) rotate(-180)\" data-v-4a222550></rect></clipPath></defs></svg>", 1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "q-text-md q-text-grey not-found-prompt"
}
const _hoisted_6 = {
  key: 0,
  class: "q-select-search__error-message"
}

import { ref, watch } from 'vue'
import { onClickOutside } from '@vueuse/core'
import type { PropType } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  items: {
    type: Array,
    default: []
  },
  selectedItem: {
    type: Object,
  },
  maxHeight: {
    type: Number,
    default: 300
  },
  required: {
    type: Boolean,
    default: false
  },
  label: String,
  placeholder: { type: String },
  error: { type: String },
  contrast: { type: Boolean },
  large: { type: Boolean },
  panelPosition: { type: String },
  method: {
    type: String,
    required: true
  }
},
  emits: ['changeSelect', 'setSwitcherValue'],
  setup(__props, { emit }) {

const props = __props

// @ts-nocheck





const isOpen = ref(false)

const targetSelect = ref(null)
onClickOutside(targetSelect, () => isOpen.value = false)

watch(
  ()=> props.selectedItem?.id,
  ()=> isOpen.value = false
)

const inputEl = ref('')

const filteredItems = computed(() => {
  if(inputEl.value !== ''){
    return props.items.filter(item => item.label.toLowerCase().includes(inputEl.value.toLowerCase()))
  } else {
    return props.items
  }
})

const target = ref<HTMLElement | null>(null);

const openPanel = () => {
  isOpen.value = true
  inputEl.value = ''
  setTimeout(()=> target.value.focus(), 0)
  filteredItems.value = props.items
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["q-select-search", {open: isOpen.value, error: __props.error, contrast: __props.contrast, large: __props.large}]),
    ref_key: "targetSelect",
    ref: targetSelect
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["q-select-search__selected", {'empty': !__props.selectedItem?.label.length}]),
        onClick: openPanel
      }, [
        (isOpen.value)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputEl).value = $event)),
              placeholder: "Введите назваоние перевозчика",
              ref_key: "target",
              ref: target
            }, null, 512)), [
              [_vModelText, inputEl.value]
            ])
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.selectedItem?.label.length ? __props.selectedItem?.label : __props.placeholder), 1)),
        _hoisted_3
      ], 2),
      _createVNode(_Transition, { name: "bottom" }, {
        default: _withCtx(() => [
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["q-select-search__list promt-block", {'q-select-search__list--top': __props.panelPosition === 'top'}])
              }, [
                _createElementVNode("div", {
                  class: "promt-block__list",
                  style: _normalizeStyle({maxHeight: __props.maxHeight+'px'})
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredItems), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["promt-block__item", {'active-item': item.id === __props.selectedItem?.id}]),
                      key: item.id,
                      onClick: ($event: any) => (_ctx.$emit('changeSelect', item))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ], 10, _hoisted_4))
                  }), 128)),
                  (!_unref(filteredItems).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Ничего не нашлось"))
                    : _createCommentVNode("", true)
                ], 4)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "bottom" }, {
      default: _withCtx(() => [
        (__props.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.error), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})